import * as React from "react"

const SvgConsentThreeATwoEnd = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 967 1326"
  >
    <g
      style={{
        isolation: "isolate",
      }}
    >
      <g id="Layer_15" data-name="Layer 15">
        <path
          d="M454.59,531c132.77,35.93,234-39.46,299.83-115.41,57.75-66.59,76.32-152.91,89.9-240C858.59,84,901.34,40,962,1.14V.5H0V814.78S186.58,458.5,454.59,531Z"
          fill="#351377"
        />
        <path
          d="M667,1.5S469,113.29,463,317.4c-3.47,118.21-61.79,176.35-110.26,204.34A271.74,271.74,0,0,1,452.59,530c132.77,35.93,234-39.46,299.83-115.41,57.75-66.59,76.32-152.91,89.9-240C856.58,83.09,899.25,39.07,959.82.26Z"
          fill="#2b1266"
        />
      </g>
      <g id="Layer_13" data-name="Layer 13">
        <g>
          <path
            d="M644.11,1180.83c1,11.46,1.45,25.48-1.45,36.78-.39,1.51-.82,3-1.22,4.46h.16c5.36,1.1,10.85,1.09,16.3,1.13s10.9.44,16.37.64c3.22.11,6.45.09,9.67,0l1.23-5.12c1.46-33.76,17.9-86.26,17.9-135.75,0-80.14-23.86-89-21.64-168.26.25-9,2.8-15.21,5.5-23.74H599.18c5.73,22.1,5.88,36.77,6.45,50.09,1.74,41,13.35,52,13.35,52C637.7,1071.65,637.44,1101.34,644.11,1180.83Z"
            fill="#d69b6d"
          />
          <path
            d="M619.38,992.37A36.66,36.66,0,0,0,652,988.66c.75-.49-.06-1.61-.8-1.12A35.22,35.22,0,0,1,620,991.12c-.82-.31-1.4.94-.57,1.25Z"
            fill="#bc835a"
          />
          <g>
            <rect
              x={642.77}
              y={1227.5}
              width={50.88}
              height={36.09}
              transform="translate(-582.37 1904.31) rotate(-89.57)"
              fill="#305387"
            />
            <path
              d="M553.55,1299.83h0a18.15,18.15,0,0,1,16-17.88h0a73.54,73.54,0,0,0,59.61-45.68l10.24-25.54a2.68,2.68,0,0,1,4-1.23l4.14,2.81a17,17,0,0,1,7.45,14.18l-.21,27.36a12.74,12.74,0,0,0,12.63,12.84h0a12.75,12.75,0,0,0,12.83-12.64l.21-28.13a8.31,8.31,0,0,1,8.38-8.26l2.69,0a.85.85,0,0,1,.85.85s5,11.51,3.49,74.08c-.06,2.32-4.28,8.26-4.28,8.26l-35.15,1-2.92-5.91-32.89,9.57-61.15-.46Z"
              fill="#a9c9c3"
            />
            <path
              d="M553.55,1299.83l60.71.45a73.6,73.6,0,0,0,21.37-3l7.72-2.26a66.84,66.84,0,0,1,19.27-2.68l33.24.25a1.33,1.33,0,0,1,1.32,1.34l0,2.55a13.1,13.1,0,0,1-13.19,13l-28.17-.21a2.57,2.57,0,0,1-2.54-2.56v-3.19a1.7,1.7,0,0,0-2.17-1.63l-14.49,4.14a83.12,83.12,0,0,1-23.31,3.16l-50.89-.38a8.94,8.94,0,0,1-8.86-9Z"
              fill="#305387"
            />
          </g>
        </g>
      </g>
      <g id="eyes">
        <path
          d="M624.52,384.93c-6.11-9.56-19.85-16.19-30.44-9.86a5.59,5.59,0,0,0-1,.76,4.64,4.64,0,0,0-3.25,3.3c-1.74,5.8-6.18,9.79-6.6,16.18-.36,5.54,1.1,12.73,4.09,17.47A9.58,9.58,0,0,0,593,417c3.38.77,6-1.37,9.28-1.15,6.86.45,12,7.5,18.64,1.66C629.69,409.77,630.65,394.52,624.52,384.93Z"
          fill="#dbc3a1"
        />
        <path
          d="M591,672.44s33.22.91,48.57.89c14.36,0,57.34-1.22,57.34-1.22,15.32,27.62,9.54,94.87,10.53,103.2,8.24,69.43-24.35,80-20.31,159.86,0,0-10-5.71-40.59-5.71-23.11,0-46.86,5.26-46.86,5.26C601.9,875.77,571.22,790.76,591,672.44Z"
          fill="#694c51"
        />
        <path
          d="M571.33,800.29a178.91,178.91,0,0,0,35.77,52c14.75,14.85,32.81,29.49,53.34,35.68,11.74,3.53,24.49,4,36.24.27a3.9,3.9,0,0,0,2.73-4.36l-.85-4.74a3.89,3.89,0,0,0-4.93-3c-18.29,5-39.57-2.73-54-12.8a168.59,168.59,0,0,1-40.56-40.13,164.08,164.08,0,0,1-16.1-28c-3.31-7.29-15-2.26-11.62,5.07Z"
          fill="#382632"
        />
        <path
          d="M637.52,426.82c-8.54,3.86-37.31,23.12-37.31,23.12-15.74,17.83-19.74,32-24.27,49.42-6.38,24.58-7.7,68.61-7.73,85.17-.05,25.44-3.07,47.24-2.57,70.75,1.16,54.86-8.43,141.64-8.43,141.64,10,8.29,46.08,3.74,82,7.36,55,5.52,86.42-7.36,86.42-7.36-3-17.2-10.42-79.83-6.34-149.27,6.34-107.87-11.54-182.9-33.7-217C685.63,430.6,655.68,418.6,637.52,426.82Z"
          fill="#13a89e"
        />
        <path
          d="M600.33,685.07c-12.67,33.31-23.22,54.6-33.86,71.3-2.12,3.32-12.06,12.85-12.3,25.85-.36,18.76,11.22,35.92,15.61,33.87.65-.3,4.27-2.88,6.38-9.75,3.29-10.71,11.87-12.17,14.45-18.75,4.9-12.48,2.81-18.87,4.52-24.12,4.38-13.44,22.52-36.83,39.38-65.17C625.44,691.65,612,684.51,600.33,685.07Z"
          fill="#d69b6d"
        />
        <path
          d="M600.21,449.94c.3-1.78,15.48-18.81,15.71-20.61,4.55-35-4-73.41-4-73.41l49-.72,7,52,.16,1.2c32.15,31.13,50.24,81.49,30.6,88.57-10.11,3.64-17.4,1.63-42.56-13.44l-49.37-12.31Z"
          fill="#d69b6d"
        />
        <path
          d="M616.25,385.79l.38,5c23.79.06,33.25-28.2,33.25-28.2C641.69,364.3,616.25,385.79,616.25,385.79Z"
          fill="#9e695c"
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M656.45,338.78c0-.17-1.72-5.86-1.76-8.26C654.24,300,635,278,611.92,275.92c-14.59-1.28-25.13-1.71-31.42,6-5.28,6.47-7.42,19.81-7.78,32.12-.33,11.45-5.44,16.27-10.4,22.21a3.54,3.54,0,0,0,3.64,5.54l4-.44a1.69,1.69,0,0,1,1.85,1.42A80.63,80.63,0,0,0,578,364.49c6.37,13.5,14.39,25.65,35.54,21.86,23.51-4.21,37.67-25.91,42.67-33.8A109.68,109.68,0,0,0,656.45,338.78Z"
          fill="#d69b6d"
        />
        <path
          d="M586.4,326.38a2.41,2.41,0,1,1-2.38-2.81A2.63,2.63,0,0,1,586.4,326.38Z"
          fill="#382632"
        />
        <path
          d="M582,280.06a38.72,38.72,0,0,1,23.9-25c.83-.29.47-1.62-.37-1.33a40.13,40.13,0,0,0-24.86,25.93.69.69,0,0,0,1.33.37Z"
          fill="#e8d1b5"
        />
        <path
          d="M601.16,919.92c13-4.74,27.77-5,41.49-5.74,14.46-.78,29-.38,43,3.48a.69.69,0,0,0,.37-1.33c-14.16-3.9-28.81-4.32-43.4-3.53-13.82.74-28.73,1-41.85,5.79-.83.3-.48,1.64.36,1.33Z"
          fill="#5b3f45"
        />
        <path
          d="M689.76,806.2q-.25,10.51-.51,21a3.7,3.7,0,0,0,.81,3,7.6,7.6,0,0,0,3.09,1.49,79,79,0,0,0,9.83,2.59c.87.17,1.24-1.17.36-1.34a77.64,77.64,0,0,1-8.37-2.11c-1.19-.37-3.05-.68-3.91-1.62s-.39-3.43-.36-4.71l.45-18.33a.7.7,0,0,0-1.39,0Z"
          fill="#5b3f45"
        />
        <path
          d="M634.89,699.4c1.27.8,2.68,1.41,4,2.1l4,2.08c1.54.82,3.09,1.64,4.62,2.48a25.35,25.35,0,0,1,2.81,1.63c.72.53,1.41-.67.7-1.19a25.43,25.43,0,0,0-2.81-1.64c-1.53-.84-3.08-1.66-4.63-2.47q-2-1-4-2.08c-1.34-.69-2.75-1.31-4-2.11-.75-.47-1.45.72-.69,1.2Z"
          fill="#19bcac"
        />
        <path
          d="M591.33,789.66l67.91,2.06c21.78.65,42.45-.48,63.33-7.24.84-.27.48-1.61-.37-1.33-21.61,7-43.05,7.79-65.54,7.11l-65.33-2c-.89,0-.89,1.36,0,1.38Z"
          fill="#19bcac"
        />
        <path
          d="M633.29,590.89a29.26,29.26,0,0,1,19.61,8.63.69.69,0,0,0,1-1,30.8,30.8,0,0,0-20.59-9c-.89,0-.89,1.35,0,1.39Z"
          fill="#19bcac"
        />
        <path
          d="M608.43,664.17c4.71-.15,9.51,1.7,13.9,3.24a113.87,113.87,0,0,1,13.48,5.7c6.3,3.15,13.1,6.95,18.16,12a.69.69,0,0,0,1-1,60.77,60.77,0,0,0-6.52-5.1,77.93,77.93,0,0,0-12.68-7.46,119.13,119.13,0,0,0-13-5.47c-4.52-1.58-9.41-3.44-14.27-3.29a.7.7,0,0,0,0,1.39Z"
          fill="#19bcac"
        />
        <path
          d="M570,550.6a443.33,443.33,0,0,0,68.15,5.82.7.7,0,0,0,0-1.39,439.64,439.64,0,0,1-67.78-5.76c-.87-.15-1.25,1.18-.37,1.33Z"
          fill="#f9f5ec"
        />
        <path
          d="M569.27,567.53c10.82,1.71,21.63,3.67,32.49,5.07,11.35,1.46,22.89,1.07,34.3,1.12a.69.69,0,0,0,0-1.38c-11-.05-22.16.33-33.12-1-11.14-1.33-22.22-3.41-33.3-5.17-.87-.13-1.25,1.2-.37,1.34Z"
          fill="#f9f5ec"
        />
        <path
          d="M639,556.32c18.22,4,36.65,8,55.39,7.11.85,0,.86-1.42,0-1.38-18.63.88-36.93-3.06-55-7.07-.83-.18-1.19,1.15-.35,1.34Z"
          fill="#f9f5ec"
        />
        <path
          d="M636.58,573.53c9.41,2.63,18.88,5.16,28.41,7.28,9.1,2,18.11,1.83,27.36,1.27.87-.05.87-1.44,0-1.38-9.48.58-18.63.71-28-1.44s-18.35-4.52-27.46-7.06a.69.69,0,0,0-.36,1.33Z"
          fill="#f9f5ec"
        />
        <path
          d="M699.81,562.83a109.39,109.39,0,0,0,18.88-.89c.76-.1.77-1.48,0-1.38a109.39,109.39,0,0,1-18.88.89c-.78,0-.78,1.35,0,1.38Z"
          fill="#f9f5ec"
        />
        <path
          d="M697.58,581.68a94.84,94.84,0,0,0,22.08-.51c.77-.1.77-1.49,0-1.38a94.84,94.84,0,0,1-22.08.51c-.78-.08-.77,1.31,0,1.38Z"
          fill="#f9f5ec"
        />
        <path
          d="M600.33,683.58c12.27-28.24,24.6-56.68,31.88-86.54a225.07,225.07,0,0,0,6.2-41.74c.87-16.77,1-33.91,12.44-47.71.51-.62-.4-1.5-.91-.88-8.06,9.75-11,21.24-12,33.43-1.48,17.21-2,34.09-5.7,51.09-7,31.85-20.14,62.07-33.16,92-.32.73.93,1,1.25.33Z"
          fill="#19bcac"
        />
        <path
          d="M651.35,707.3c2.51-16.77,5.3-33.85,13.77-49,8.66-15.46,19.44-29.35,24.3-46.48,4.74-16.71,7.36-33.78,9-51,1.7-18,5.54-36,.87-53.9a.69.69,0,0,0-1.33.35c4.75,18.2.66,36.68-1.06,55s-4.52,36.94-10.41,54.5c-5.69,16.94-18.06,30.58-25.57,46.67-6.38,13.67-8.69,28.78-10.9,43.47-.12.83,1.21,1.19,1.34.35Z"
          fill="#19bcac"
        />
        <path
          d="M656.45,483.51a39,39,0,0,1,13.08-7.05c5-1.57,10.55-2.36,15.67-.8a.7.7,0,0,0,.37-1.34c-5.34-1.62-11.17-.83-16.41.8a40.94,40.94,0,0,0-13.69,7.41c-.69.57.3,1.54,1,1Z"
          fill="#894e46"
        />
        <path
          d="M578.49,789.8c-7.93,5-10.6,14.47-11,23.33,0,.89,1.35.89,1.39,0,.35-8.35,2.8-17.41,10.29-22.13.75-.48.06-1.67-.7-1.2Z"
          fill="#bc835a"
        />
        <path
          d="M564.59,789.66a26.06,26.06,0,0,0-2.83,8.47c-.62,3-1.21,6.12-.34,9.15a.69.69,0,0,0,1.33-.37c-.82-2.88-.19-5.84.4-8.7a24.48,24.48,0,0,1,2.63-7.86.69.69,0,0,0-1.19-.69Z"
          fill="#bc835a"
        />
        <path
          d="M556.3,787.34a18.31,18.31,0,0,0-.53,6.21.71.71,0,0,0,.69.7.69.69,0,0,0,.69-.7,17,17,0,0,1,.49-5.85.69.69,0,0,0-1.34-.36Z"
          fill="#bc835a"
        />
        <ellipse
          cx={583.54}
          cy={352.7}
          rx={5.59}
          ry={3.02}
          transform="translate(-58.51 123.15) rotate(-11.48)"
          fill="#fff"
        />
        <path
          d="M604.17,444.45s58.13-.72,78.48-19.33c0,0,21.28,23.18,25.81,63.78l-7,9.68L670.64,501,629,490.5l-34-16-1.59-16.12S604.33,444.4,604.17,444.45Z"
          fill="#13a89e"
        />
        <path
          d="M719.74,378.72c-2.79-4.28-6.35-7.87-7.6-13-1.19-4.88-.6-10.08-.31-15,.62-10.51-1.4-19.19-4.57-29.14a50.58,50.58,0,0,1-2.64-15.76c0-5.62.5-11.23-.21-16.83-1-8.06-4.65-16.22-11.79-20.63-3.32-2.06-8.45-2.08-11.24-4.74-1.55-1.47-2.32-4.14-3.41-5.95a30.16,30.16,0,0,0-4-5.2,34.41,34.41,0,0,0-23.6-10.17,35.91,35.91,0,0,0-14,2.79c-6.1,2.29-11.33,1.24-17.63.6-10.41-1.05-21.49,0-29.93,6.73a29.64,29.64,0,0,0-11.14,21.51,5.17,5.17,0,0,0-.33,1.68c-.33,8.54,5.54,15.45,12.72,19.38,8.64,4.74,19.23,4.57,27.64,9.66,3.21,2,6.81,5.2,6.75,9.28-.06,4.34-2.07,7.72.67,11.84,2.06,3.1,6.33,3.41,8.34,6.07s-1.14,9.45-1,12.72c.43,9.11,9.41,13.16,11.61,21.25,1.31,4.81-.37,10-1.26,14.76A52.59,52.59,0,0,0,642,396.1c.86,8.08,1.73,20.88,9.6,25.49,6.39,3.75,14.82,1.5,20.53-2.5,7.84-5.5,11.72-13.69,22.4-13.5,8.19.16,17.09,1.7,24-3.88C726,395.72,724.46,385.94,719.74,378.72Z"
          fill="#dbc3a1"
        />
        <path
          d="M595.53,390.71c-2.64,1.43-2.53,4.86-1.67,7.32.55,1.56,1.43,3.14,1.49,4.83,0,1.27-.36,2.87-1.68,3.38-.89.34-.5,1.79.4,1.44,2.92-1.11,3.16-4.59,2.32-7.18-.53-1.61-1.45-3.2-1.59-4.91a3.56,3.56,0,0,1,1.48-3.59c.85-.46.1-1.75-.75-1.29Z"
          fill="#e8ceaf"
        />
        <path
          d="M607.39,396.44c-1.28,2.21-.67,4.75-.16,7.1.4,1.89.69,4.33-1,5.71-.74.62.32,1.67,1.06,1.06,1.73-1.43,1.87-3.82,1.58-5.89-.32-2.33-1.5-5-.21-7.23a.75.75,0,0,0-1.3-.75Z"
          fill="#e8ceaf"
        />
        <path
          d="M601.33,276.93c-.17,4.8,4.32,7.73,8.2,9.49,5.62,2.54,11.67,4.22,17.16,7.05,2.47,1.28,4.81,3,5.88,5.69s.83,5.57.66,8.33a25.62,25.62,0,0,0,.33,8.15,16,16,0,0,0,2.93,5.57c2.65,3.43,6.2,6.1,8.61,9.71a10.12,10.12,0,0,1,1.9,5.75c0,2.85-1.29,5.49-1.12,8.38.58,10.11,10.17,16.89,12.25,26.57,2.58,12-4.13,24.77,1.73,36.21.44.86,1.74.1,1.3-.76-5.18-10.11-.08-21.88-1.09-32.57-.48-5.1-2.55-9.48-5.26-13.76s-5.88-8.34-7.06-13.24a16.15,16.15,0,0,1,.28-7.66,11.68,11.68,0,0,0-.13-6.73c-1.38-3.82-4.57-6.67-7.32-9.52a29.84,29.84,0,0,1-4.18-5.14,13.81,13.81,0,0,1-1.83-7.44c0-5.17,1.35-10.83-2.28-15.18a18.25,18.25,0,0,0-6.91-4.62c-3.15-1.37-6.39-2.58-9.58-3.85-4.52-1.81-13.19-4.19-13-10.43,0-1-1.47-1-1.5,0Z"
          fill="#e8ceaf"
        />
        <path
          d="M642.71,273.23c6.58,4.86,13.6,10.19,17.33,17.68,2.13,4.26,2.43,8.72,2.35,13.4-.07,4.47,0,8.94,2.11,13,1.8,3.4,4.54,6.16,6.76,9.29a18.1,18.1,0,0,1,2.63,5,15.47,15.47,0,0,1,.22,7.16c-.38,2.33-.94,4.63-1.1,7a18.24,18.24,0,0,0,.86,6.64c1.43,4.59,3.87,8.8,5.46,13.34a72.05,72.05,0,0,1,3.38,33.24c-.12.94,1.32,1.35,1.45.4a73.84,73.84,0,0,0-2-29.51,103.21,103.21,0,0,0-5.37-14,25.94,25.94,0,0,1-2.24-7.18,25.13,25.13,0,0,1,.62-7.58c.83-4.41,1.15-8.53-1-12.62-1.84-3.5-4.7-6.31-6.94-9.54a18,18,0,0,1-2.72-5.55,28.55,28.55,0,0,1-.67-7.72c0-4.62.11-9.13-1.63-13.5-3.51-8.76-11.42-14.8-18.77-20.23-.78-.57-1.53.73-.76,1.3Z"
          fill="#e8ceaf"
        />
        <path
          d="M697.61,355.84c-1.94,6.56,2.69,12.86,4.37,19a41.7,41.7,0,0,1,.25,21c-.23.94,1.21,1.34,1.44.4a43.17,43.17,0,0,0,.19-20.06,64.73,64.73,0,0,0-3.36-9.64c-1.31-3.26-2.48-6.74-1.45-10.25a.75.75,0,0,0-1.44-.4Z"
          fill="#e8ceaf"
        />
        <path
          d="M581.81,309.88c0-1.93.83-2.37,3.48-1.82a20.42,20.42,0,0,1,7.4,3.69c4.5,3.59,6.71,9.94,5.56,8.55a30.56,30.56,0,0,0-9.52-8.05C586,310.78,581.8,310.33,581.81,309.88Z"
          fill="#513715"
        />
      </g>
    </g>
  </svg>
)

export default SvgConsentThreeATwoEnd
